import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@99designs/common/components/Icon';

const WorkRelationshipDescriptions = ({ workRelationshipDescriptions }) => {
    if (workRelationshipDescriptions.length === 0) return null;
    return (
        <div className="work-relationship-descriptions">
            {workRelationshipDescriptions.map(description => (
                <div key={description.text} className="work-relationship-descriptions__details">
                    <div className="work-relationship-descriptions__icon">
                        <Icon variations={[`icon icon--${description.icon}`]} />
                    </div>
                    <div className="work-relationship-descriptions__text">{description.text}</div>
                </div>
            ))}
        </div>
    );
};

WorkRelationshipDescriptions.propTypes = {
    workRelationshipDescriptions: PropTypes.array.isRequired,
};

export default WorkRelationshipDescriptions;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/WorkRelationshipDescriptions.jsx